import type { EmployeeAssignmentDto } from './employee-assignments.dto.js';

export const employeeStatusValues = ['active', 'inactive'] as const;
export type EmployeeStatus = (typeof employeeStatusValues)[number];

export const employmentTypeValues = ['full_time', 'part_time', 'contractor'] as const;
export type EmploymentType = (typeof employmentTypeValues)[number];

export interface EmployeeDto {
  id: string;
  companyId: string;
  storeId: string;
  locationId: string | null;
  userId: string | null;
  employeeNumber: string | null;
  timezone?: string;
  firstName: string;
  lastName: string;
  displayName: string;
  status: EmployeeStatus;
  hireDate: string | null; // ISO date (YYYY-MM-DD)
  terminationDate: string | null; // ISO date (YYYY-MM-DD)
  employmentType: EmploymentType | null;
  assignments?: EmployeeAssignmentDto[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateEmployeeRequest {
  companyId: string;
  storeId: string;
  locationId?: string | null;
  timezone?: string;
  firstName: string;
  lastName: string;
  displayName?: string;
  employeeNumber?: string | null;
  userId?: string | null;
  hireDate?: string | null; // ISO date (YYYY-MM-DD)
  terminationDate?: string | null; // ISO date (YYYY-MM-DD)
  employmentType?: EmploymentType | null;
}

export interface CreateEmployeeResponse {
  employee: EmployeeDto;
}

export interface UpdateEmployeeRequest {
  companyId: string;
  employeeId: string;
  firstName?: string;
  lastName?: string;
  displayName?: string;
  status?: EmployeeStatus;
  storeId?: string;
  locationId?: string | null;
  employeeNumber?: string | null;
  userId?: string | null;
  timezone?: string | null;
  hireDate?: string | null; // ISO date (YYYY-MM-DD)
  terminationDate?: string | null; // ISO date (YYYY-MM-DD)
  employmentType?: EmploymentType | null;
}

export interface UpdateEmployeeResponse {
  employee: EmployeeDto;
}

export interface ListEmployeesRequest {
  companyId: string;
  storeId?: string;
  locationId?: string;
  status?: EmployeeStatus;
}

export interface ListEmployeesResponse {
  items: EmployeeDto[];
}
